// extracted by mini-css-extract-plugin
module.exports = {"row":"s__row__2Vs89"};